import { ViewChild, Component, ElementRef } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { Md5 } from 'ts-md5/dist/md5';

/**
 * Generated class for the ConfirmreqPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-confirmreq',
  templateUrl: 'confirmreq.html',
})
export class ConfirmreqPage {
  _enterpass: any = ''
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public alertCtrl: AlertController, public gn: GN, public toastCtrl: ToastController) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConfirmreqPage');
    var _that = this
    setTimeout(() => {
      _that._enterpass = ''
    }, 1000);
  }

  checkPass() {


    //NLB
    //if (this.gn.decrypt(this.gn.user.password) == Md5.hashStr(this._enterpass)) {
    if (this.gn.decrypt(this.gn.user.password) == this._enterpass) {
      var _cb = this.navParams.get('cb')
      if (_cb != null) {
        _cb();
        this.navCtrl.pop()
      }
    } else {
      const toast = this.toastCtrl.create({ message: this.dic.l["usinfo04"], duration: 3000, position: 'top' });
      toast.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/confirmreq/confirmreq.ts